import React from "react";
import { Outlet } from "react-router-dom";

const Email = () => {
  return <Outlet />;
};

export default Email;
